export const COUNTDOWN_VIEWS = {
  block: 'block',
  string: 'string',
};

export const COUNTDOWN_TYPES = {
  independent: 'independent', // independent tastic
  inner: 'inner', // as part of Hero or other tastics
};

export const COUNTDOWN_TIMEZONES = {
  aest: 'aest',
  aedt: 'aedt',
};

const getUserTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// Determine if daylight saving time is currently in effect for the specified zone
const isDaylightSaving = (): boolean => {
  const now = new Date();
  const jan = new Date(now.getFullYear(), 0, 1);
  const jul = new Date(now.getFullYear(), 6, 1);
  const stdOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  return now.getTimezoneOffset() < stdOffset;
};

export const getUserTimezoneFormat = (): string => {
  const userTimeZone = getUserTimezone();
  const isDST = isDaylightSaving();

  if (userTimeZone === 'Australia/Sydney') {
    return isDST ? COUNTDOWN_TIMEZONES.aedt : COUNTDOWN_TIMEZONES.aest;
  }
  if (userTimeZone === 'Australia/Brisbane') {
    return COUNTDOWN_TIMEZONES.aest;
  }
  return COUNTDOWN_TIMEZONES.aest;
};

export const adjustForTimezone = (countdownTo: string, selectedTimezone: string, userTimezone: string): Date => {
  const countdownDate = new Date(countdownTo);

  if (selectedTimezone === COUNTDOWN_TIMEZONES.aedt && userTimezone === COUNTDOWN_TIMEZONES.aest) {
    countdownDate.setHours(countdownDate.getHours() + 1);
  } else if (selectedTimezone === COUNTDOWN_TIMEZONES.aest && userTimezone === COUNTDOWN_TIMEZONES.aedt) {
    countdownDate.setHours(countdownDate.getHours() - 1);
  }
  return countdownDate;
};
